import "./migrateMessage.scss";

const MigrateMessage = ({
    Heading = "Migration in progress",
    SubHeading = "Your Organization is migrating the storage.",
    Content = "Please wait till we process migration.",
    Note = "Close the tab and retry in the new tab.",
    loading = true
}) => {
    return (
        <>
            <div className="processing-message">
                {loading && <div className="processing-container">
                    <div className="spinner"></div>
                </div>}
                <h2>{Heading}</h2>
                <p>{SubHeading}</p>
                <p><strong>{Content}</strong></p>
                <p><strong>{Note}</strong></p>
            </div>
        </>
    );
};

export default MigrateMessage;